import { Directive, forwardRef, OnChanges, Input, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validators, Validator, ValidatorFn } from '@angular/forms';

export class CustomValidator {
    static min(minNumber: number): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            const currentVal = control.value;
            return (currentVal >= minNumber) ? null : {'belowMin': {currentVal}};
        };
    }
    static max(MaxNumber: number): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            const currentVal = control.value;
            return (currentVal <= MaxNumber) ? null : {'overMax': {currentVal}};
        };
    }
    static letters(mustBeFilled?: boolean): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            const currentVal = control.value;
            let NAME_REGEXP = /^[a-zA-Z- ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏàáâãäåæçèéêëìíîïÐÑÒÓÔÕÖØÙÚÛÜÝÞßðñòóôõöøùúûüýþÿ]*$/;
            if(!NAME_REGEXP.test(control.value) || (mustBeFilled && !currentVal)) {
                return {"incorrectNameString": {currentVal} };
            }
            return null;
        };
    }
    static mailFormat(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            let EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i;

            if (control.value && control.value != "" && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
                return { "incorrectMailFormat": true };
            }

            return null;
        }
    }
    static expDateValidator(userLocalDate?: string): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            let month = control.get('exp_month');
            let year = control.get('exp_year');
            let errorObject = {'pastDate': true};
            let currentDate = userLocalDate ? new Date(userLocalDate) : new Date();

            if (month.untouched || year.untouched) return null;

            let currentMonth = parseInt((currentDate.getMonth() + 1).toString());
            let currentYear = parseInt(currentDate.getFullYear().toString().substr(2,2));

            if (year.value > currentYear) {
                return null;
            } else if (year.value < currentYear) {
                return errorObject;
            } else if (year.value == currentYear && month.value < currentMonth) {
                return errorObject;
            } else {
                return null;
            }
        }
    }
}

@Directive({
    selector: '[min][ngControl],[min][ngFormControl],[min][ngModel]',
    providers: [{
        provide: NG_VALIDATORS, useExisting: forwardRef(() => MinValidatorDirective), multi: true
    }],
    host: {'[attr.min]': 'min ? min : null'}
})

export class MinValidatorDirective implements Validator, OnChanges {
    private valFn = Validators.nullValidator;

    @Input() min: number;

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['min'];
        if (change) {
            this.valFn = CustomValidator.min(change.currentValue)
        } else {
            this.valFn = Validators.nullValidator;
        }
    }

    validate(control: AbstractControl): {[key: string]: any} {
        return this.valFn(control);
    }
}

@Directive({
    selector: '[max][ngControl],[max][ngFormControl],[max][ngModel]',
    providers: [{
        provide: NG_VALIDATORS, useExisting: forwardRef(() => MaxValidatorDirective), multi: true
    }],
    host: {'[attr.max]': 'max ? max : null'}
})

export class MaxValidatorDirective implements Validator, OnChanges {
    private valFn = Validators.nullValidator;

    @Input() max: number;

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['max'];
        if (change) {
            this.valFn = CustomValidator.max(change.currentValue)
        } else {
            this.valFn = Validators.nullValidator;
        }
    }

    validate(control: AbstractControl): {[key: string]: any} {
        return this.valFn(control);
    }
}

@Directive({
    selector: '[letters][ngControl],[letters][ngFormControl],[letters][ngModel]',
    providers: [{
        provide: NG_VALIDATORS, useExisting: forwardRef(() => LettersValidatorDirective), multi: true
    }],
    host: {'[attr.letters]': 'letters ? letters : null'}
})

export class LettersValidatorDirective implements Validator, OnChanges {
    private valFn = Validators.nullValidator;

    @Input() letters: string;

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['letters'];
        if (change) {
            this.valFn = CustomValidator.letters()
        } else {
            this.valFn = Validators.nullValidator;
        }
    }

    validate(control: AbstractControl): {[key: string]: any} {
        return this.valFn(control);
    }
}

@Directive({
    selector: '[email][ngControl],[email][ngFormControl],[email][ngModel]',
    providers: [{
        provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailValidatorDirective), multi: true
    }],
    host: {'[attr.email]': 'email ? email : null'}
})

export class EmailValidatorDirective implements Validator, OnChanges {
    private valFn = Validators.nullValidator;

    @Input() email: string;

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['email'];
        if (change) {
            this.valFn = CustomValidator.mailFormat()
        } else {
            this.valFn = Validators.nullValidator;
        }
    }

    validate(control: AbstractControl): {[key: string]: any} {
        return this.valFn(control);
    }
}